import * as React from 'react';
import sortBy from 'sort-by';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { IAssociatesReportPage } from 'Module/AssociatesReport/Interface';
import { ColumnDef, Row } from '@tanstack/react-table';
import { TanstackTable } from 'Shared/Components/Mui/TanstackTable/index';
import RegisterStructure from 'Shared/Constant/HomeTargetsSupplier/RecordStructure';
import { IHomeTargetsSupplier } from 'Module/HomeUser/Interface/HomeTargetsSupplier';
import { IFieldStructure } from 'Shared/Interfaces/ObjectSalesforce';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { KEY_HOMETARGETSSUPPLIER_SELECTED } from 'Shared/Constant/Cache';

function PaperComponent(props: PaperProps) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default function AssociateReportModalSupplierPage(props: IAssociatesReportPage) {
  const [open] = React.useState(true);

  const [columns, setColumns] = React.useState<ColumnDef<object, any>[]>([]);
  const toggleSetColumns = (values: ColumnDef<object, any>[]) => {
    setColumns(values);
  }

  const [data, setData] = React.useState<object[]>([]);
  const toggleSetData = (values: [IHomeTargetsSupplier?]) => {
    const _array: object[] = values.map(reg => reg || {});
    setData(_array);
  }

  const toggleSetItemSelected = (item: IHomeTargetsSupplier) => {
    const _item: IHomeTargetsSupplier = item;

    if (props.toggleSetTargetSupplierSelected) {
      props.toggleSetTargetSupplierSelected(_item);
    }
    if (props.toggleSetCache) {
      props.toggleSetCache(KEY_HOMETARGETSSUPPLIER_SELECTED, _item);
    }

    if (props.toggleShowModalAssociateProductDetail) {
      props.toggleShowModalAssociateProductDetail(true);
    }
  }

  const getFieldsStructure = React.useCallback((list: IFieldStructure[]) => {
    const _array: ColumnDef<object, any>[] = [];
    if (list && list.length > 0) {
      for (let regField of list.sort(sortBy('orderFormMain'))) {
        let _column: ColumnDef<object, any> | null = null;
        if (regField.viewFormMain) {
          switch (regField.type) {
            case 'checkbox':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField!,
                header: regField.label,
                cell: ({ row }) => {
                  const rowData = row.original as any;
                  if (regField.nameField === 'active') {
                    return (<input type="checkbox" checked={rowData.active} readOnly />);
                  }
                  if (regField.nameField === 'isMeta') {
                    return (<input type="checkbox" checked={rowData.isMeta} readOnly />);
                  }
                  return (<input type="checkbox" checked={Boolean(row.getValue(regField.nameField!))} readOnly />);
                },
              };
              break;
            case 'currency':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField!,
                header: regField.label,
                meta: {
                  align: 'right',
                },
              };
              break;
            default:
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField!,
                header: regField.label,
              };
              break;
          }
          if (!_column || regField.hiddenFormMain) {
            continue;
          }
          if (regField.width || regField.cellStyle) {
            _column.meta = {
              ...(typeof _column.meta === 'object' ? _column.meta : {}),
              cellSx: regField.cellStyle,
              headerSx: regField.width ? { width: regField.width } : undefined,
            };
          }

          switch (regField.nameField) {
            case 'qtCxFaturada':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrVenda':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'valorBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              // _column.render = (rowData: any) => parseFloat(rowData.valorBase.replace(/\./g, '').replace(/,/g, '.')).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', currencyDisplay: 'narrowSymbol' }).replace('R$', ''); // Formata o número no formato pt-br sem moeda
              break;
            case 'qtdeBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'mix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaFaturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'faturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentFaturmento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'caixas':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'qtUnitCx':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrUnitario':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            default:
              break;
          }

          _array.push(_column);
        }
      }
    }
    toggleSetColumns(_array);

  }, [])

  const handleClose = () => {
    if (props.toggleShowModalAssociateDetail) {
      props.toggleShowModalAssociateDetail(false);
    }
  };

  React.useEffect(() => {
    getFieldsStructure(RegisterStructure);
    toggleSetData(props?.listModalTargetsSupplier || []);
  }, [props.listModalTargetsSupplier, props.dateUpdateInfo, getFieldsStructure])

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Grid container spacing={1}>
            <Grid item xs={6} sm={8} md={9} lg={10} xl={10}>
              <Typography component={'div'} align='left'>
                <span className='AssociatesReportModalTitle'>{props?.titleModalTargetsSupplier || 'Metas'}</span>
                {props.showLoadingUpdateTable && (
                <Typography component='span' sx={{ display: 'inline-flex', width: 120 }}>
                  <LinearProgress />
                </Typography>
              )}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
              <Typography component={'div'} align='right'>
                <Button
                  variant="contained"
                  color="success"
                  className="ButtonDanger"
                  type="button"
                  autoFocus
                  onClick={handleClose}
                >
                  <span>Fechar</span>
                </Button>
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'div'}>
            <TanstackTable
              data={data}
              columns={columns}
              title="Metas fornecedores"
              isLoading={props.showLoadingThisPage}
              enableGlobalFilter
              stickyHeader
              onRowClick={(row: Row<object>) =>
                toggleSetItemSelected(row.original as IHomeTargetsSupplier)
              }
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </div>
  );
}
